import {Divider, Menu, MenuProps, Modal, Space} from 'antd'
import React, {useEffect, useState} from 'react'
import Input from '../../components/UI/Input'
import {
  AuditOutlined, DeleteOutlined, EditOutlined, EyeOutlined,
  FileTextOutlined,
  HomeOutlined,
  MinusOutlined,
  PlusOutlined,
  PrinterOutlined,
  TagsOutlined, ToolOutlined
} from "@ant-design/icons";
import Button from "../../components/UI/Button";
import List from "../../components/List";
import {compareNumbers, stringCompare} from "../../utils/sorters";
import {sendSystemLog} from "../../context/AuthProvider/useAuth";
import {getAllowCreateNewDevicePermission, getPermission} from "../../services/permisssion";
import permissionType from "../../utils/permissionType";
import {getDevicesList} from "../../services/devices";
import loading from "../../components/UI/Loading";
import {useLoading} from "../../context/LoadingProvider/useLoading";
import {addTag, addTagToDevices, deleteTag, getAllTags, getDeviceTags, removeTagFromDevices} from "../../services/tags";

interface modalTagsSelectorProps {
  visible: boolean
  title: string
  tags?: never[]
  onSelectChange: (val: never[]) => void
  onClose: () => void
  isManufacturer: boolean
}


function SearchTagsSelector(props: modalTagsSelectorProps) {
  const [search, setSearch] = useState('')
  const loading = useLoading()

  const [addTagOptions, setAddTagOptions] = useState([])
  const [addSearchTags, setAddSearchTags] = useState([])
  const [searchTagText, setSearchTagText] = useState('')

  // @ts-ignore
  const filteredAddOptions = addTagOptions.filter(option => option.name.toLowerCase().includes(search.toLowerCase()))

  useEffect(() => {
    (async() =>{
      loading.addLoading()
      const res = await getAllTags()
      if (res) {
        setAddTagOptions(res.tags)
        if (props.tags)
          setAddSearchTags(props.tags)
      }
      loading.removeLoading()
    })()
  }, [props.visible])

  const addTagToSearch = (record:any) => {
    let temp = [...addSearchTags]
    // @ts-ignore
    temp.push(record)
    setAddSearchTags(temp)
  }
  const removeTagFromSearch = (record:any) => {
    // @ts-ignore
    const temp = addSearchTags.filter(option => option.id!==record.id)

    // @ts-ignore
    setAddSearchTags(temp)

  }

  useEffect(() => {
    {
      let text = addSearchTags.map((tag: any) => tag.distributorId!==null && props.isManufacturer? tag.name + ' (D)': tag.name).join()
      text  = text.replace(',', ', ')
      setSearchTagText(text)
      props.onSelectChange(addSearchTags)
    }
  }, [addSearchTags])

  const getActionButtons = (id: string, record: any) => {
    let addButton = true
    addSearchTags.forEach(function(tag){
      // @ts-ignore
      if (tag.id === id)
        addButton = false
    })
    return(
        <>
        {addButton &&
        <div className="cashiers__table__actions">
          <Button
              onClick={() => addTagToSearch(record)}
              type='secondary'
              style={{backgroundColor: '#2fa4e7'}}
          >
            <PlusOutlined style={{fontSize: '16px', color: '#FFF'}}/>
          </Button>
        </div>
        }
          {!addButton &&
              <div className="cashiers__table__actions">
                <Button
                    onClick={() => removeTagFromSearch(record)}
                    type='secondary'
                    style={{backgroundColor: 'red'}}
                >
                  <MinusOutlined style={{fontSize: '16px', color: '#FFF'}}/>
                </Button>
              </div>
          }
        </>
    )
  }



  return (
    <>
        <Modal open={props.visible} title={props.title} onCancel={props.onClose} onOk={props.onClose}
               cancelButtonProps={{ style: { display: 'none' } }}
               okButtonProps={{ style: { display: 'none' } }}
        >
          <div className="modal-selector">
            <>
              {searchTagText}
            <div className="modal-selector__search" >
              <Input
                  label="Filter"
                  value={search}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                  placeholder="Tag to search"
              />

            </div>
            <div className="modal-selector__options">
              <List

                  rows={filteredAddOptions}
                  columns={[
                    {
                      title: 'Actions',
                      dataIndex: 'id',
                      key: 'id',
                      render: (value: string, record: any) => getActionButtons(value, record),
                      width: 50
                    },

                    {
                      title: 'Tag',
                      dataIndex: 'name',
                      key: 'name',
                      render: (value: string, record: any) => record.distributorId!==null && props.isManufacturer?value + ' (D)': value,
                      sorter: (a: any, b: any) => stringCompare(a.name, b.name),
                    },
                  ]}
              />
            </div>
            </>
            {
              props.isManufacturer &&
              <>
              (D) - Distributor tag
              </>
            }
          </div>
        </Modal>
    </>
  )
}

export default SearchTagsSelector

